import { graphql } from "relay-runtime"

export const GeneralHealthInformationFragment = graphql`
  fragment GeneralHealthInformationFragment on GeneralHealthInformation {
    conditions
    allergies
    medication
  }
`
